import React, { useState } from "react";
import { Box, Flex, Button } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { UserSessionDropdown } from "@/components/UserSessionDropdown";
import FeedbackModal from "@/js/components/FeedbackModal";
import { DistrictSupportWindow } from "@/js/components/DistrictSupportWindow";
import { useSelectedClassroomStore } from "@/stores/v2/selectedClassroomStore";
import { ChakraFAIcon } from "@/components/ui/Icon";

interface Props {
	classroomName?: string;
}

export function NavRightActions(props: Props): JSX.Element {
	const { t } = useTranslation();
	const [showDistrictContactDetails, setShowDistrictContactDetails] = useState<boolean>(false);
	const [showFeedbackModal, setShowFeedbackModal] = useState<boolean>(false);
	const classroomId = useSelectedClassroomStore().stableIdV1;

	const handleOpenDistrictContactDetails = (): void => {
		setShowDistrictContactDetails(true);
	};

	const closeDistrictContactDetails = (): void => {
		setShowDistrictContactDetails(false);
	};

	const toggleFeedbackModal = (): void => {
		setShowFeedbackModal(!showFeedbackModal);
	};

	return (
		<Flex gap={2} alignItems={"center"} mx={5} zIndex={99}>
			<Button
				variant="ghost"
				onClick={handleOpenDistrictContactDetails}
				color="inherit"
				leftIcon={<ChakraFAIcon icon="fa-circle-phone" variant="solid" color="#68768B" boxSize={5} />}
				aria-label={t("overview.support")}
			>
				{t("overview.support")}
			</Button>
			{classroomId && (
				<Button
					variant="ghost"
					onClick={toggleFeedbackModal}
					color="inherit"
					leftIcon={<ChakraFAIcon icon="fa-message-dots" variant="solid" color="#68768B" boxSize={5} />}
					aria-label={t("overview.sendFeedback")}
				>
					{t("overview.sendFeedback")}
				</Button>
			)}
			<Box height={"20px"} borderRight={"2px solid rgba(255, 255, 255, 0.3)"} />
			<UserSessionDropdown />
			<DistrictSupportWindow open={showDistrictContactDetails} okay={closeDistrictContactDetails} />
			{showFeedbackModal && props.classroomName && <FeedbackModal classroomName={props.classroomName} handleClose={toggleFeedbackModal} />}
		</Flex>
	);
}
